import { tw } from '@careinfo/tailwind';
import { useMemo } from 'react';
import APIS from '../../constant/EndPoint';
import Button from '../Reusable/Button';
import DataTable from '../Reusable/DataTable';
import NACell from '../Reusable/DataTable/NACell';
import LocationSelect from '../Reusable/LocationSelect';
import { useParams } from 'react-router-dom';

const LocationList = (props) => {
  const { receiverLocation, handleAsync, isLoading } = props;
  const { slug } = useParams<{ slug: string }>();
  const partnerName = slug?.replace(/-/g, ' ');
  const defaultColumns = [
    {
      header: 'Our Location',
      accessorKey: 'sender_location_name',
      cell: NACell,
    },
    {
      header: `${partnerName} Location`,
      accessorKey: 'receiver_location_name',
      cell: ({ row, getValue }) => {
        const selectedValue = getValue();
        return useMemo(
          () => (
            <LocationSelect
              id={row?.original?.id}
              value={selectedValue}
              options={receiverLocation}
              slug={slug}
            />
          ),
          [selectedValue, row?.original?.id, receiverLocation, slug]
        );
      },
    },
  ];

  return (
    <DataTable
      url={APIS.LOCATION}
      queryKey={`location-${slug}`}
      params={{
        delivery_partner__slug: slug,
      }}
      columns={defaultColumns}
      // addNewPagePath='create'
      tableName='Location'
      actionMenu={
        <div className={tw`flex w-full justify-end`}>
          <div className={tw`w-24`}>
            <Button
              label={'Sync'}
              type={'button'}
              onClick={() => handleAsync()}
              isLoading={isLoading}
            />
          </div>
        </div>
      }
    />
  );
};

export default LocationList;
